<template>
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
      <p class="category">{{category}}</p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">{{categorySecond}}</div>
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-sm-6">
          <el-select
            class="select-default"
            style="width: 5.5em"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          &nbsp;
          <div style="display: inline-block">
            <el-select
              class="el-select"
              style="width: 8em"
              v-model="currentsearchType"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in searchType"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div style="display:inline-block">
            <fg-input class="input-sm"
                      placeholder="搜索"
                      v-model="searchQuery"
                      @keyup.enter="getData">
            </fg-input>
          </div>
          <p-button @click="getData">搜索</p-button>
        </div>

        <!--搜索 -->
        <div class="col-sm-6">

          <div class="pull-right">
            <p-button type="info" plain @click="selectGameAccount">
              选择游戏
            </p-button>
          </div>
        </div>


        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    @selection-change="handleSelectionChange"
                    style="width: 100%">
            <el-table-column type="selection" v-model="course">
            </el-table-column>
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>

          </el-table>
        </div>
        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{page}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :page-count="pagination.page_count">
          </p-pagination>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option, Dialog} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Search from 'src/components/UIComponents/Search/Search.vue'
  import {getFetch} from 'src/util/fetch'
  import {Cookie} from 'src/util/cookie'

  import {upLoadFile} from "../../../../util/upload";
  import Syptpacking from "../Packing/Syptpacking";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Dialog)
  export default {
    watch: {
      'pagination.perPage'() {
        this.getData()
      },
      'pagination.currentPage'() {
        this.getData()
      },
    },
    components: {
      PPagination,
      Search,
    },
    computed: {
      queriedData() {
        return this.tableData
      },
      to() {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total() {
        return this.total_count
      },
      page() {
        return `从 ${this.from + 1} 到 ${this.to} 共 ${this.total} 条`
      },

    },
    data() {//定义tabel
      return {
        getToken: {
          token: '',
        },
        resoucreList: [],
        apklist: [],
        title: '第一事业部游戏列表',
        multipleTable: [],     //存放选中值的数组
        category: '',
        categorySecond: '',
        dialogResourceVisible: false,
        dialogapkVisible: false,
        pagination: {//分页
          perPage: 30,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          page_count: 0,
          total: 0
        },
        searchQuery: '',//搜索值
        currentsearchType: '游戏id',
        searchType: ['游戏id', '游戏名'],//搜索字段
        tableColumns: [//列表
          {
            prop: 'gid',
            label: '游戏id',
            minWidth: 100
          },
          {
            prop: 'name',
            label: '游戏名',
            minWidth: 100
          },
          {
            prop: 'alias',
            label: '游戏别名',
            minWidth: 100
          },
          {
            prop: 'floor',
            label: '事业部',
            minWidth: 100
          },
          {
            prop: 'father_path',
            label: '母包地址',
            minWidth: 200
          },

        ],
        tableData: [],//渲染table数据

        //获取游戏信息批量传输给后台
        course: [],
        total_count: 0,

      }
    },


    open() {
      this.$alert('这是一段内容', '标题名称', {
        confirmButtonText: '确定',
        callback: action => {
          this.$message({
            type: 'info',
            message: `action: ${action}`
          });
        }
      });
    },
    methods: {
      handleSelectionChange(val) {
        this.multipleTable = val;               //  this.multipleTable 选中的值
        //console.log(val);
      },

      //选择游戏跳转到打包页
      selectGameAccount() {
        var list = []

        for (var i = 0; i < this.multipleTable.length; i++) {
          list.push(this.multipleTable[i].gid)
        }
        // if(this.multipleTable.length == 0)
        // {
        //
        //   this.$alert('执行此操作前，请先勾选需要配置打包的游戏', '提示', {
        //     confirmButtonText: '确定',
        //     center: true,
        //     callback: action => {
        //       this.$message({
        //         type: 'info',
        //         center: true,
        //         message: `action: ${ action }`
        //       });
        //     }
        //   });
        // }else{
        this.addBuildGameAPI(list)
        this.$router.push('/packing/syptpacking')//跳转打包页

        // }


      },
      //进度条
      handleProgress(event, file, fileList) {
        // console.log("122", event)
        // console.log(file.name)
        // console.log(fileList)

      },

      checkfile(file, filelist) {
        for (let i = 0; i < filelist.length; i++) {
          if (filelist[i].name === file.name) {
            filelist.splice(i, 1)
          }
        }
      },
      apkhandleChange(file, fileList) {
        if (file.name.endsWith(".apk")) {
        } else {
          swal({
            title: "文件格式错误",
            timer: 1000,
            showConfirmButton: false
          })
          this.checkfile(file, fileList)
        }
      },
      resourceChange(file, fileList) {
        if (file.name.endsWith(".zip")) {
        } else {
          swal({
            title: "文件格式错误",
            timer: 1000,
            showConfirmButton: false
          })
          this.checkfile(file, fileList)
        }
      },
      getMyToken() {
        this.getToken.token = Cookie().get("token")
      },

      async submitUpload() {
        //console.log('上传')
        this.$refs.upload.submit()
      },

      cractResource() {
        this.dialogResourceVisible = true
        this.getMyToken()
      },
      cractApk() {
        this.dialogapkVisible = true
        this.getMyToken()
      },

      changeTotal(length) {
        this.pagination.total = length
      },
      async getData(page, size) {
        page = this.pagination.currentPage
        size = this.pagination.perPage
        // name = this
        // type = this
        // gid = this
        let req_data = {}
        req_data['size'] = size
        req_data['page'] = page
        if (this.searchQuery !== '') {
          if (this.currentsearchType === this.searchType[0]) {
            req_data['type'] = 1
            req_data['gid'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[1]) {
            req_data['type'] = 2
            req_data['name'] = this.searchQuery
          } else {
            //console.log('预留')
          }
        }

        let opt = {
          url: '/api/games/syptgames/',
          type: 'GET',
          data: req_data,
          //  如果需要接入第三方的接口，需要添加此参数
          // host:window.Config.homeHost
        }

        const res = await getFetch(this, opt);
        if (res.code === 0) {

          var list = []
          for (var i = 0; i < res.data.games.results.length; i++) {
            var data = res.data.games.results[i]
            if (data.father_path == null) {
              data.father_path = "未上传母包"
            } else if (data.father_path == 0) {
              data.father_path = "文件处理中"
            }
            // if (data.resource_path == null) {
            //     data.resource_path = "未上传资源包"
            // } else if (data.resource_path == 0) {
            //     data.resource_path = "文件处理中"
            // }

            if (data.floor == "sypt") {
              data.floor = "第一事业部"
            } else {
              data.floor = "第二事业部"
            }
            list.push(data)
          }

          this.tableData = list//res.data.games.results
          this.changeTotal(res.data.games.total_count)
          this.total_count = res.data.games.total_count
          this.pagination.page_count = res.data.games.total_page
        }
      },


      //添加预打包游戏API
      async addBuildGameAPI(gidList) {
        let opt = {
          url: "/api/sypt/package/",
          type: "post",
          data: {
            gid: gidList,
          }
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.$router.push('/packing/syptpacking')//跳转打包页
        }
      },


    },
    mounted() {
      this.getData();
    }
  }
</script>

